/**
 * As tags de um contato vivem como texto dentro de `account_contacts.tags`, e a
 * gravação sempre normaliza esse array para minúsculas. Se `account_tags.name`
 * guardar outra caixa, a linha da tag deixa de casar com o que está no contato:
 * quem aplicar "VIP" pela tela e "vip" por um fluxo acaba com duas tags que a
 * lista mostra separadas. Por isso o nome é normalizado em todo ponto de escrita.
 */

export function normalizeTagName(name: string): string {
  return name.trim().toLowerCase();
}

/** Mesma tag independentemente da caixa e dos espaços das pontas. */
export function isSameTagName(a: string, b: string): boolean {
  return normalizeTagName(a) === normalizeTagName(b);
}

export function findTagByName<T extends { name: string }>(
  tags: T[],
  name: string
): T | undefined {
  const normalized = normalizeTagName(name);
  return tags.find((tag) => normalizeTagName(tag.name) === normalized);
}

/** Remove vazios e repetidos por caixa, preservando a ordem de entrada. */
export function normalizeTagNames(names: string[]): string[] {
  const seen = new Set<string>();
  const result: string[] = [];
  for (const name of names) {
    const normalized = normalizeTagName(name);
    if (!normalized || seen.has(normalized)) continue;
    seen.add(normalized);
    result.push(normalized);
  }
  return result;
}
